// 受けの結果のフック (2026-10-31)。 src/hits.ts が攻撃1つの解決ごとに呼ぶ。
//   取り付いた記録係 (開発版 src/dev_playlog.ts・配布版 src/playtest_upload.ts) へ配るだけ。
//   誰も取り付いていなければ何もしない (テスト・ラボ・送信を断った人)。 戦闘の状態には触らない。

import type { ActiveHit, Boss, Player } from './types'

export type RecvSink = {
  recv(res: string, hit: ActiveHit, p: Player, b: Boss, time: number, extra?: Record<string, unknown>): void
}

const sinks: RecvSink[] = []

export function addRecvSink(s: RecvSink): void { if (!sinks.includes(s)) sinks.push(s) }
export function removeRecvSink(s: RecvSink): void {
  const i = sinks.indexOf(s)
  if (i >= 0) sinks.splice(i, 1)
}

export function playlogRecv(res: string, hit: ActiveHit, p: Player, b: Boss, time: number, extra?: Record<string, unknown>): void {
  for (let i = 0; i < sinks.length; i += 1) sinks[i]!.recv(res, hit, p, b, time, extra)
}
